import { useState, useEffect, Fragment } from 'react';
import { Outlet, useNavigate, useParams } from "react-router-dom";
import Image from '../login/login_background.webp'; // Import using relative path
import { useDispatch } from "react-redux";
import {
    Box, Card, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CardActions, CardContent,
    Button, Typography, TextField, Backdrop, CircularProgress, List, ListItem, ListItemText, InputAdornment
} from '@mui/material';

import { useLoginMutation } from '../../redux/api/authApiSlice';
import { useExchangeTokenMutation } from '../../redux/reducers/resetPasswordSlice';
import { setCredentials } from "../../redux/reducers/authSlice";
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from "@mui/material/IconButton";

const ResetPasswordForm = (props) => {
    const params = useParams();
    const [initResetPassword, { data: resetPasswordRes, isLoading: resetPasswordLoading, error: resetPasswordLoadingError, isSuccess, isError }] = useExchangeTokenMutation();

    const [formData, setFormData] = useState({ password: '', rePassword: '' });
    const [message, setMessage] = useState(null);
    const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const [showPassword1, setShowPassword1] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const submit = async () => {
        try {
            if (formData.password.trimStart().trimEnd() !== formData.rePassword.trimStart().trimEnd()) {
                setMessage('Las contraseñas no coinciden.');
                return;
            }
            let objPetition = {
                password: formData.password.trimStart().trimEnd(),
                confirmPassword: formData.rePassword.trimStart().trimEnd(),
                resetPasswordToken: params.token
            };
            const resetPasswordRes = await initResetPassword(objPetition).unwrap();
            console.log(resetPasswordRes)
            setMessage('Contraseña actualizada. Redirigiendo...');
            setTimeout(() => {
                navigate("/login");
            }, 3000);
        } catch (err) {
            console.error(err);
            setMessage('Error al actualizar la contraseña.');
        }
    };

    return (
        <Fragment>
            <Box sx={{ minWidth: 275, width: 400, padding: 20 }}>
                <Card variant="outlined">
                    <Fragment>
                        <CardContent sx={{ display: 'grid', padding: 5, paddingBottom: 0 }}>
                            <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#868686', marginBottom: 3 }} color="text.primary" gutterBottom>
                                Ingrese su Nueva Contraseña.
                            </Typography>

                            <TextField id="outlined-basic" name='password' type={showPassword1 ? 'text' : "password"} label="Contraseña" variant="standard" value={formData.password} onChange={handleChange}
                                InputProps={{
                                    endAdornment: (<InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword1(!showPassword1)}
                                        >
                                            {showPassword1 ? <VisibilityOutlinedIcon color='secondary' /> : <VisibilityOffOutlinedIcon color='secondary' />}
                                        </IconButton>
                                    </InputAdornment>)
                                }} />

                            <TextField id="outlined-basic" name='rePassword' type={showPassword2 ? 'text' : "password"} label="Re ingrese la contraseña" variant="standard" value={formData.rePassword} onChange={handleChange}
                                InputProps={{
                                    endAdornment: (<InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword2(!showPassword2)}
                                        >
                                            {showPassword2 ? <VisibilityOutlinedIcon color='secondary' /> : <VisibilityOffOutlinedIcon color='secondary' />}
                                        </IconButton>
                                    </InputAdornment>)
                                }} />

                            {message && <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#868686', marginBottom: 3 }} color="text.primary" gutterBottom> {message} </Typography>}
                        </CardContent>
                        <CardActions>
                            <Button variant='contained' sx={{ padding: 1, marginLeft: 4, fontWeight: 'bold' }} size="small" onClick={submit}>Aceptar</Button>
                            <Button variant='outlined' sx={{ padding: 1, margin: 3, fontWeight: 'bold' }}
                                size="small" onClick={() => navigate("/login")}>Volver a Login</Button>
                        </CardActions>
                    </Fragment>
                </Card>
            </Box>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={resetPasswordLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </Fragment>
    )
}


const ResetPassword = () => {
    return (
        <div style={{
            backgroundImage: `url(${Image})`, backgroundSize: "cover",
            backgroundRepeat: "no-repeat", height: "100vh", display: 'flex', justifyContent: 'center'
        }}>
            <ResetPasswordForm></ResetPasswordForm>
        </div>
        //<img src={Image} /> 
    );
}

export default ResetPassword